import transformHeading from '@activebrands/core-web/libs/storyblok/utils/transform-heading';
import transformFeatureItemData from '@activebrands/core-web/utils/transform-feature-item-data';
import FeaturePromotion from 'components/content-components/Promotional/FeaturePromotion';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import transformParagraph from '@activebrands/core-web/libs/storyblok/utils/transform-paragraph';
import transformTag from '@activebrands/core-web/libs/storyblok/utils/transform-tag';
import transformAnchorTag from '@activebrands/core-web/libs/storyblok/utils/transform-anchor-tag';

const FeaturePromotionDataTransformerBlock = ({ content = {} }: any) => {
    const { _editable, anchorTag = [], heading = [], items = [], paragraph = [], tag = [] } = content;

    if (!items.length) {
        return null;
    }

    return (
        <FeaturePromotion
            columnSizes={[6, null, null, null, null, 3]}
            features={items.map(feature => transformFeatureItemData(feature))}
            heading={transformHeading({ heading, defaultType: 'h3' })}
            id={transformAnchorTag({ anchorTag })}
            imageSettings={{ width: [200, 300, 400, 500, 600], sizes: ['70vw', null, null, '33vw', null, '25vw'] }}
            sbEditable={transformPreviewEditable(_editable)}
            slidesPerView={[1.4, null, 2.6, null, null, 3]}
            tag={transformTag({ tag })}
            paragraph={transformParagraph({ paragraph })}
        />
    );
};

export default FeaturePromotionDataTransformerBlock;
